// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f5f5;
}
.app-container {
  display: flex;
  min-height: 100vh;
}
.sidenav {
  width: 220px;
  flex-shrink: 0;
}
.main-content {
  flex: 1;
  padding: 24px;
  margin-left: 220px;
  min-height: 100vh;
  background-color: #f5f5f5;
}

/* admin-certilife ant-design.scss 의 .security-modal 중 이 앱에 필요한 것(복사한 2차 인증 창들) */
.security-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}
.modal-title {
  font-size: 16px;
  font-weight: bold;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
